import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { CoverageHistoryMode } from '@/components/smartai/api/getCoverageHistory';

interface CoverageHistoryNavLinkProps {
  dbRepoId: string;
  bucket: CoverageHistoryMode;
}

export function CoverageHistoryNavLink({
  dbRepoId,
  bucket,
}: CoverageHistoryNavLinkProps) {
  if (!dbRepoId) return null;

  return (
    <Button variant="outline" size="sm" className="h-8 gap-1.5" asChild>
      <Link
        to={`/sia/components/coverage_analysis/trend/${dbRepoId}?bucket=${bucket}`}>
        <TrendingUp className="h-3.5 w-3.5" aria-hidden />
        Coverage trend
      </Link>
    </Button>
  );
}
